<template>
  <canvas id="chart" width="100%" height="100%"></canvas>
</template>

<script>
  import { Chart } from 'chart.js'

  export default {
    name: 'Chart',
    props: ['data'],
    data: function() {
      return {
        chart: undefined,
      };
    },
    watch: {
      data: function(val) {
        this.chart.data.datasets = JSON.parse(JSON.stringify(val));
        this.chart.update();
      }
    },
    mounted: function() {
      var ctx = document.getElementById('chart').getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'bar',

        // Configuration options go here
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      });

      this.chart.data.datasets = JSON.parse(JSON.stringify(this.data));
      this.chart.update();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
